import { Button, Dialog as DialogDS, Heading } from "@digdir/designsystemet-react";
import { QuestionmarkCircleIcon } from "@navikt/aksel-icons";
import { useRef } from "react";
import "./Dialog.css";

export const Dialog = ({ children, isModal }: { children: React.ReactNode; isModal?: boolean }) => {
    const dialogRef = useRef<HTMLDialogElement>(null);

    const handleOpen = () => {
        if (isModal === false) {
            dialogRef.current?.show();
        } else {
            dialogRef.current?.showModal();
        }
    };

    return (
        <>
            <Button variant="primary" data-color="kraftoransje" onClick={handleOpen}>
                <QuestionmarkCircleIcon aria-hidden="true" />
                Dette må du vite om tallene
            </Button>
            <DialogDS
                ref={dialogRef}
                placement="top" // NB: Placement for Dialog needs to be 'top', since the app is embedded into a page area on enova.no
                className="dialog"
                modal={isModal} // NB: Setting modal to true will only prevent interaction with the rest of the page, but not scrolling, since the app is embedded into a page area on enova.no.
            >
                <DialogDS.Block>
                    <Heading level={2} data-size="sm">
                        Dette må du vite om tallene
                    </Heading>
                </DialogDS.Block>
                <DialogDS.Block>{children}</DialogDS.Block>
                <DialogDS.Block>
                    <Button
                        variant="primary"
                        data-color="kraftoransje"
                        onClick={(e) => e.currentTarget.closest("dialog")?.close()}
                    >
                        Den er grei
                    </Button>
                </DialogDS.Block>
            </DialogDS>
        </>
    );
};
